export default __webpack_public_path__ + "static/media/Logo_EPS_300.ea086194.png";